import Separator from '@flatsy/core/Layout/Separator/'
import { useBrowser } from '@flatsy/utils/Hooks/UseBrowser'
import React, { ElementType, useState } from 'react'
import HeaderBrowser from '../Browser'

export const withHeader = (Component: ElementType): React.FC => (props) => {
  const browser = useBrowser()
  const [closeBrowser, setCloseBrowser] = useState(false)
  const handleToggleCloseBrowser = (value: boolean) => {
    setCloseBrowser(value)
  }

  return (
    <>
      <HeaderBrowser
        absolute={false}
        browser={browser}
        close={closeBrowser}
        setClose={handleToggleCloseBrowser}
      />
      {localStorage.getItem('browserInformation') !== 'true' &&
        !closeBrowser &&
        !browser.isFullSupport && <Separator size="60px" />}
      <Component {...props} />
    </>
  )
}
